import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NgZorroAntdModule } from "ng-zorro-antd";
import { MaterialModule } from "src/app/core/material";
import { NgMatAutocompleteModule } from "src/app/shared/components/autocomplete/autocomplete.module";
import { SharedModule } from "src/app/shared/shared.module";
import { LinkAccountComponent } from "./link-account.component";
import {LinkAccountRoutingModule} from './link-account.routing';


@NgModule({
  declarations: [
    LinkAccountComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    NgZorroAntdModule,
    NgMatAutocompleteModule,
    LinkAccountRoutingModule
  ],
  entryComponents: [

  ]
})
export class LinkAccountModule { }
